import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from "@angular/core";
import { MoodTask } from "../../taskbook.types";
import { MoodsService } from "../../../timeline/timeline-item/moods/moods.service";
import { GifPreview, LinkPreview } from "@teammood/timeline";

@Component({
    selector: 'mood-task',
    templateUrl: './mood-task.component.html',
    styleUrls: ['./../task.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MoodTaskComponent implements OnChanges {

    icon: string;

    @Input() task: MoodTask

    @Output() onComment = new EventEmitter()
    @Output() onReported = new EventEmitter()

    constructor(
        private moodsService: MoodsService
    ){}

    ngOnChanges(changes: SimpleChanges): void {
        if(changes.task?.currentValue){
            this.icon = this.moodsService.build_icon(this.task.mood, this.task.date);
        }
    }

    toGifPreview(linkPreview: LinkPreview): GifPreview {
        return new GifPreview((linkPreview));
    }

    comment(){
        this.onComment.emit('');
    }

    achive(){
        this.task = undefined
    }
    
    reportItem(){
        this.onReported.emit();
    }
}